import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION26: PdfComponent = {
  type: 'section',
  id: 's26',
  title: '26. Further Assurance',
  content: [
    {
      type: 'altText',
      id: 's26bullets',
      content: [
        'Each party shall, at the request of the other and at the cost of the requesting party, do all acts and execute all documents necessary to give full effect to this Agreement.',
      ],
      boldFirst: false,
    },
  ],
};
